import { InspectorControls } from '@wordpress/block-editor';

import ChartSettings from './chart-settings';
import DataControls from './data-controls';
import AxisControls from './axis-controls';
import LabelsControls from './labels-controls';
import MarkControls from './mark-controls';

export default function AllInspectorControls( props ) {
	return (
		<InspectorControls>
			<ChartSettings { ...props } />
			<DataControls { ...props } />
			{ /* A pie has no axes to configure. */ }
			{ ! props.config.isRadial && <AxisControls { ...props } /> }
			<LabelsControls { ...props } />
			<MarkControls { ...props } />
		</InspectorControls>
	);
}
